import script from "./userDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./userDetail.vue?vue&type=script&setup=true&lang=js"

import "./userDetail.vue?vue&type=style&index=0&id=19b1003b&lang=less"

const __exports__ = script;

export default __exports__